export const getLastName = (fullName: string): string => {
  const parts = fullName?.split(' ');
  let lastName = parts?.[parts.length - 1] || '';
  lastName =
    lastName.length > 2
      ? lastName.charAt(0).toUpperCase() + lastName.substring(1).toLowerCase()
      : lastName;

  return lastName;
};
